/**
 * 用于检测字符串中是否包含emoji表情
 */
export const startWithEmojiRegex = /^(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/gi; // eslint-disable-line
